import sliderFunction from "../components/slider/functions";
import sliderPartenaires from "../components/slider/partenaires";
import collapse from "../components/collapse/collapse";
import OpenHeader from "../animations/pageTransitions/OpenHeader";
import FilterFaq from "../components/filters/filterFaq";
import FilterMaj from "../components/filters/filterMaj";
import FilterCareer from "../components/filters/filterCareer";
import FilterVideos from "../components/filters/FilterVideos";
import NavTabSBuilder from "../components/navtabs/navTabs_builder";
import FilterCollapseBuilder from "../components/filters/filterCollapseBuilder";
import FilterAvantages from "../components/filters/filterAvantages";
import mainNavbar from "../components/navbar/mainNavbar";
import responsiveNavbar from "../components/navbar/responsiveNavbar";
import lightbox from "../components/lightbox/SimpleLightbox";
import ContactForm from "../components/forms/contactForm";

export default function scripts() {

    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = (urlParams.get('item')) ? urlParams.get('item') : false;

    if (paramValue && $('#' + paramValue).length > 0) {
        const offset = 120;
        const element = document.getElementById(paramValue);
        const y = element.getBoundingClientRect().top + window.scrollY - offset;

        window.scroll({
            top: y,
            left: 0,
        });
    } else {
        window.scroll({
            top: 0,
            left: 0,
        });
    }

    ContactForm();
    sliderFunction();
    sliderPartenaires();
    collapse();
    OpenHeader();
    FilterFaq();
    FilterMaj();
    FilterCareer();
    FilterVideos();
    NavTabSBuilder();
    FilterCollapseBuilder();
    FilterAvantages();
    mainNavbar();
    responsiveNavbar();
    lightbox();
}
